import * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'
import { cva } from 'class-variance-authority'

import { cn } from '~/lib/utils'

const switchStyles = cva('', {
  variants: {
    colour: {
      'light-blue':
        'data-[state=checked]:bg-blue-l dark:data-[state=checked]:bg-blue-l',
      'mid-blue':
        'data-[state=checked]:bg-blue-m dark:data-[state=checked]:bg-blue-m'
    }
  },
  defaultVariants: {
    colour: 'mid-blue'
  }
})

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    className?: string
    bgColour?: 'light-blue' | 'mid-blue' | undefined | null
  }
>(({ className, bgColour, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      switchStyles({ colour: bgColour }),
      'peer h-s disabled:bg-grey-m data-[state=unchecked]:bg-grey-m disabled:data-[state=checked]:bg-grey-m dark:data-[state=unchecked]:bg-grey-m inline-flex w-[44px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-hidden disabled:cursor-not-allowed dark:focus-visible:ring-neutral-300 dark:focus-visible:ring-offset-neutral-950',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'h-xs-plus w-xs-plus data-disabled:bg-grey-l data-[state=checked]:data-disabled:group-hover:translate-x-xs-plus pointer-events-none block rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-1px)] data-[state=checked]:group-hover:translate-x-[calc(100%-4px)] data-[state=unchecked]:translate-x-[1px] data-[state=unchecked]:group-hover:translate-x-[4px] data-[state=unchecked]:data-disabled:group-hover:translate-x-0 dark:bg-white'
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
